import { Truck, ShieldCheck, Sparkles, Gift } from "lucide-react";
import { Reveal } from "../site/Reveal";

const items = [
  { Icon: Truck, title: "Fast & Reliable Shipping", desc: "Free on orders $75+" },
  { Icon: ShieldCheck, title: "Secure Checkout", desc: "Powered by Stripe" },
  { Icon: Sparkles, title: "Exclusive Deals", desc: "Fresh drops weekly" },
  { Icon: Gift, title: "The Luxe List Rewards", desc: "Perks for members" },
];

export const TrustRow = () => (
  <section data-testid="trust-row" className="border-y border-plum/10 bg-white">
    <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
      {items.map(({ Icon, title, desc }, i) => (
        <Reveal key={title} delay={i * 0.08} y={16} className={`group flex items-center gap-4 px-5 sm:px-8 py-7 ${i % 2 === 0 ? "border-r border-plum/10" : ""} ${i < 2 ? "border-b lg:border-b-0 border-plum/10" : ""} ${i === 1 ? "lg:border-r" : ""}`}>
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-gold/50 text-plum transition-[background-color,color,transform] duration-500 group-hover:rotate-[-8deg] group-hover:bg-plum group-hover:text-gold">
            <Icon className="h-5 w-5" strokeWidth={1.5} />
          </span>
          <div>
            <p className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em] text-plum">{title}</p>
            <p className="mt-1 text-xs sm:text-sm text-plum/70">{desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
